import { axios } from '@/utils/request'

const api = {
  kaojiList: '/adminapi/kaojiexame/kaojilist',
  kaojiYundongyuanList: '/adminapi/kaojiexame/kaojiYundongyuanList',
  mingdanSave: '/adminapi/kaojiexame/mingdanSave',
  score1Save: '/adminapi/kaojiexame/score1Save',
  score1List: '/adminapi/kaojiexame/score1List',
  score2Save: '/adminapi/kaojiexame/score2Save',
  score2List: '/adminapi/kaojiexame/score2List',
  scoreConfirm: '/adminapi/kaojiexame/scoreConfirm',
  getAllCertUrls: '/adminapi/kaojiexame/getAllCertUrls',
  setCertFace: '/adminapi/kaojiexame/setCertFace',
  scoreMemberAdd: '/adminapi/kaojiexame/scoreMemberAdd',
}

export default api

export function getKaojiList(parameter) {
  return axios({
    url: api.kaojiList,
    method: 'get',
    params: parameter
  })
}
export function getKaojiYundongyuanList(parameter) {
  return axios({
    url: api.kaojiYundongyuanList,
    method: 'get',
    params: parameter
  })
}
export function getScore1List(parameter) {
  return axios({
    url: api.score1List,
    method: 'get',
    params: parameter
  })
}
export function getScore2List(parameter) {
  return axios({
    url: api.score2List,
    method: 'get',
    params: parameter
  })
}
export function mingdanSave(parameter) {
  return axios({
    url: api.mingdanSave,
    method: 'post',
    data: parameter
  })
}
export function score1Save(parameter) {
  return axios({
    url: api.score1Save,
    method: 'post',
    data: parameter
  })
}
export function score2Save(parameter) {
  return axios({
    url: api.score2Save,
    method: 'post',
    data: parameter
  })
}
export function scoreConfirm(parameter) {
  return axios({
    url: api.scoreConfirm,
    method: 'post',
    data: parameter
  })
}
export function getAllCertUrls(parameter) {
  return axios({
    url: api.getAllCertUrls,
    method: 'post',
    data: parameter
  })
}
export function setCertFace(parameter) {
  return axios({
    url: api.setCertFace,
    method: 'post',
    data: parameter
  })
}
export function scoreMemberAdd(parameter) {
  return axios({
    url: api.scoreMemberAdd,
    method: 'post',
    data: parameter
  })
}
